module.exports = __webpack_public_path__ + "img/icon-warning-stormflo-4.4a14ae40.svg";